import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { validateAndSanitizeText, sanitizeArray } from '../utils/sanitization';

const EditPacklistModal = ({ packlist, onClose }) => {
  const { updatePacklist } = useAuth();
  const [packlistName, setPacklistName] = useState(packlist.name);
  const [items, setItems] = useState([...packlist.items]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddItem = () => {
    setItems([...items, '']);
  };

  const handleRemoveItem = (index) => {
    if (items.length > 1) {
      const newItems = items.filter((_, i) => i !== index);
      setItems(newItems);
    }
  };

  const handleItemChange = (index, value) => {
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!packlistName.trim()) {
      alert('Please enter a packlist name');
      return;
    }

    const filteredItems = items.filter(item => item.trim() !== '');

    if (filteredItems.length === 0) {
      alert('Please add at least one item to the packlist');
      return;
    }

    setIsSubmitting(true);

    try {
      // Sanitize inputs before updating
      const updatedPacklist = {
        ...packlist,
        name: validateAndSanitizeText(packlistName.trim(), 200),
        items: sanitizeArray(filteredItems, 500),
        updatedAt: new Date().toISOString()
      };

      await updatePacklist(updatedPacklist);
      onClose();
    } catch (error) {
      console.error('Error updating packlist:', error);
      alert('Failed to update packlist. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content packlist-modal">
        <div className="modal-header">
          <h3>✏️ Edit Packlist</h3>
          <button className="modal-close-button" onClick={onClose}>
            ✖️
          </button>
        </div>

        <form onSubmit={handleSubmit} className="packlist-form">
          <div className="form-group">
            <label htmlFor="packlistName">Activity Name:</label>
            <input
              id="packlistName"
              type="text"
              value={packlistName}
              onChange={(e) => setPacklistName(e.target.value)}
              placeholder="e.g., Camping Trip, Field Survey, etc."
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label>Items to Pack:</label>
            <div className="items-container">
              {items.map((item, index) => (
                <div key={index} className="item-input-row">
                  <input
                    type="text"
                    value={item}
                    onChange={(e) => handleItemChange(index, e.target.value)}
                    placeholder="Enter an item..."
                    className="item-input"
                  />
                  {items.length > 1 && (
                    <button
                      type="button"
                      className="remove-item-button"
                      onClick={() => handleRemoveItem(index)}
                      title="Remove item"
                    >
                      ➖
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="add-item-button"
                onClick={handleAddItem}
              >
                ➕ Add Item
              </button>
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="save-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? '💾 Saving...' : '💾 Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPacklistModal;
